import React from 'react'

const BackCard = (props) => {
  return (
    <div style={styles.flexItem}>
      <p style={styles.jumbotronParagraph}><h2>{props.content}</h2></p>
    </div>
  )
}

const styles = {
  flexItem: {
    width: '300px',
    margin: '10px',
    textAlign: 'center',
    height: '160px',
    border: '1px black solid',
    backgroundColor: '#8D8741',
    padding: '5px',
    color: 'black',
    borderRadius: '25px'
  },
  jumbotronParagraph: {
    lineHeight: '20px',
    padding: '5px'
  }
}

export default BackCard
